import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import styles from './MainNavigation.module.css';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import { routes } from './navigationRoutes';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import DrawerListItem from './DrawerListItem/DrawerListItem';
import { SSO_REDIRECT_TO_ADDRESS } from 'config';
import UserNavigation from './userNavigation/UserNavigation';

function MainNavigation({ user, onLogout }) {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawerOpenHandler = () => setDrawerOpen((state) => !state);
    const homeButtonClickHandler = () => window.location.assign(SSO_REDIRECT_TO_ADDRESS);

    const availableRoutes = routes.reduce((availableRoutes, { text, path, allowedRoles }) => {
        if (!checkIsAllowed(user, allowedRoles)) return availableRoutes;
        const routeItem = (
            <DrawerListItem key={text} listItemComponent={Link} listItemAttributes={{ to: path }} onClick={toggleDrawerOpenHandler} text={text} />
        );
        availableRoutes.push(routeItem);
        return availableRoutes;
    }, []);

    return (
        <div className={styles.navigation}>
            <IconButton color="primary" onClick={toggleDrawerOpenHandler}>
                <MenuIcon sx={{ color: 'var(--color-white)' }} />
            </IconButton>

            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawerOpenHandler}>
                <List sx={{ minWidth: '250px', paddingTop: 'var(--header__height--main)' }}>
                    <DrawerListItem listItemComponent={'div'} onClick={homeButtonClickHandler} text="Birdseye Home" Icon={HomeIcon} />
                    <Divider />
                    {availableRoutes}
                </List>
            </Drawer>
            <UserNavigation user={user} onLogout={onLogout} />
        </div>
    );
}

export default MainNavigation;

function checkIsAllowed(user, allowedRoles) {
    if (!allowedRoles) return true;
    let allowedAccess = false;
    if (user) {
        allowedAccess = allowedRoles.reduce((allowedAccess, allowedRole) => {
            !allowedAccess && user.roles.includes(allowedRole) && (allowedAccess = true);
            return allowedAccess;
        }, false);
    }

    return allowedAccess;
}
